import Mark from "advanced-mark.js";
import { useContext, useEffect, useRef } from "react";
import adjustHexColor from "utils/colors/adjustHexColor";
import { getRegexByTerm } from "utils/terms/regex";

import DocumentViewerContext from "../DocumentViewerContext";

const toHexInt = (str = "") => parseInt(String(str).replace(/^#/, ""), 16);

const LIGHTEN_BY = 75;
const DEFAULT_HIGHLIGHT_COLOUR = toHexInt("#FCEFC7");

const useMarkContentByTerms = () => {
  const { searchBy, termsToHighlight } = useContext(DocumentViewerContext);
  const markerRef = useRef();
  const ref = useRef();

  const onEachMarked = (term) => (element) => {
    const { className, color, isSynonym } = term;
    const isDefaultColor = toHexInt(color) === DEFAULT_HIGHLIGHT_COLOUR;
    const bgColor = isDefaultColor ? color : adjustHexColor(color, LIGHTEN_BY);

    element.dataset.termId = term.id;

    if (className) {
      element.className += ` ${className}`;
    }

    if (isSynonym) {
      element.className += " synonym";
    }

    if (color) {
      element.style.backgroundColor = bgColor;
    }
  };

  const markAllTerms = () => {
    if (!markerRef?.current) {
      markerRef.current = new Mark(ref.current);
    }

    const allTerms = [].concat(termsToHighlight);
    if (searchBy) {
      allTerms.push({
        id: "text-search",
        name: searchBy,
        color: "yellow",
      });
    }

    markerRef.current.unmark();

    allTerms.forEach((term) => {
      const regex = getRegexByTerm(term);

      markerRef.current.markRegExp(regex, {
        separateWordSearch: false,
        acrossElements: true,
        each: onEachMarked(term),
      });
    });
  };

  useEffect(() => {
    markAllTerms();
  }, [searchBy, termsToHighlight]);

  return {
    markAllTerms,
    ref,
  };
};

export default useMarkContentByTerms;
